import getFeatureFlags from './getFeatureFlags.js';

var sagas = function sagas(duck) {
  return {
    getFeatureFlags: function* getFeatureFlags$1(payload) {
      yield getFeatureFlags(Object.assign({}, payload, duck));
    }
  };
};

export { sagas as default };
//# sourceMappingURL=index.js.map
